import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageSquare } from "lucide-react";

// While the Google Ads review is active, the WhatsApp redirect route is
// fully disabled to remove every outbound link reference from the site.
// To re-enable: restore the previous implementation from git history and
// flip back the SHOW_WHATSAPP_WIDGET flag in AstrologerCard.jsx.

const WhatsAppRedirect = () => {
  useEffect(() => {
    document.title = "Chat not available — topastrologerinindia.com";
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Link to="/" className="text-sm text-slate-600 hover:text-[#16a3a8] flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <div className="text-xs font-bold text-[#0b1e3f]">topastrologerinindia.com</div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white border border-slate-200 rounded-xl p-10 text-center shadow-sm">
          <div className="w-14 h-14 mx-auto rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
            <MessageSquare className="w-7 h-7" />
          </div>
          <h1 className="mt-4 text-xl font-bold text-[#0b1e3f]">Chat not available</h1>
          <p className="mt-2 text-sm text-slate-600">
            Direct chat with this astrologer is temporarily disabled. Please return to the homepage
            to view the editorial ranking and astrologer profiles.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 mt-5 rounded text-sm uppercase btn-cta"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppRedirect;
